import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormlyFieldSelectProps } from '@ngx-formly/core/select';
import { FormlyFieldProps } from '@ngx-formly/material/form-field';
import { FormlyFieldSelect } from '@ngx-formly/material/select';

interface CustomSelectProps extends FormlyFieldProps, FormlyFieldSelectProps {
  multiple?: boolean;
  selectAllOption?: string;
  disableOptionCentering?: boolean;
  typeaheadDebounceInterval?: number;
  compareWith?: (o1: any, o2: any) => boolean;
  panelClass?: string;
  showOptionIcons?: boolean;
}

@Component({
    selector: 'lockton-apps-select-field-type',
    templateUrl: './select-field-type.component.html',
    styleUrls: ['./select-field-type.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelectFieldTypeComponent
  extends FormlyFieldSelect
  implements OnInit, FormlyFieldConfig<CustomSelectProps>
{
  override get props(): CustomSelectProps {
    return this.field.props as CustomSelectProps;
  }

  @ViewChild('select', { static: true }) matSelect!: MatSelect;

  ngOnInit(): void {
    if (this.props.readonly) {
      this.matSelect._handleKeydown = () => {};
    }
  }
}
